module.exports = __webpack_public_path__ + "img/nodata.f320a586.svg";